import { Divider, Grid, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import moment from "moment";
import React from "react";
import { getRegistrationChangeLogs } from "../../Base/Services/RegistrationChangeLogService";

export default function RegistrationChangeLogSection({ registration }) {
  const [changeLogs, setChangesLogs] = React.useState();

  React.useEffect(() => {
    getRegistrationChangeLogs(registration.registrationId).then(setChangesLogs);
  }, [registration]);

  return (
    <>
      {changeLogs ? (
        changeLogs.length > 0 ? (
          <>
            {changeLogs.map((changeLog, i) => {
              // Not sure if clever or hacky way to group dates by change
              const startNewDate =
                i === 0 ||
                moment(changeLog.changedDate).format("L") !== moment(changeLogs[i - 1].changedDate).format("L");
              return (
                <React.Fragment key={i}>
                  {startNewDate && (
                    <>
                      {i !== 0 && <Divider />}
                      <Typography variant="body1">Changes on {moment(changeLog.changedDate).format("L")}</Typography>
                    </>
                  )}
                  <Grid container spacing={1} alignItems="center" style={{ marginLeft: 12 }}>
                    <Grid item>
                      <strong>{changeLog.fieldName}</strong> was
                    </Grid>
                    <Grid item>
                      {!changeLog.oldValue ? (
                        <em> not provided </em>
                      ) : (
                        <pre style={{ backgroundColor: "#F0F0F0", padding: 2 }}>{changeLog.oldValue}</pre>
                      )}
                    </Grid>
                    <Grid item> and changed to </Grid>
                    <Grid item>
                      {!changeLog.newValue ? (
                        <em> not provided </em>
                      ) : (
                        <pre style={{ backgroundColor: "#F0F0F0", padding: 2 }}>{changeLog.newValue}</pre>
                      )}
                    </Grid>
                  </Grid>
                </React.Fragment>
              );
            })}
          </>
        ) : (
          <Typography variant="body1">
            No changes have been logged for registration {registration.userFriendlyId}.
          </Typography>
        )
      ) : (
        <Skeleton variant="rect" />
      )}
    </>
  );
}
